export const CREATE_LIKE = 'LIKES/CREATE_LIKE'
export const CREATE_LIKE_FAILED = 'LIKES/CREATE_LIKE_FAILED'
export const CREATE_LIKE_SUCCESS = 'LIKES/CREATE_LIKE_SUCCESS'

export const REMOVE_LIKE = 'LIKES/REMOVE_LIKE'
export const REMOVE_LIKE_FAILED = 'LIKES/REMOVE_LIKE_FAILED'
export const REMOVE_LIKE_SUCCESS = 'LIKES/REMOVE_LIKE_SUCCESS'
